import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/login/d2c_normal.png'
import _imports_1 from '@/assets/image/login/d2c_hover.png'
import _imports_2 from '@/assets/image/login/d2c_active.png'
import _imports_3 from '@/assets/image/login/b2b_normal.png'
import _imports_4 from '@/assets/image/login/b2b_hover.png'
import _imports_5 from '@/assets/image/login/b2b_active.png'


const _withScopeId = n => (_pushScopeId("data-v-7a168479"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "choose-plat"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "choose-plat-title" }, "登録が完了しました", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "choose-plat-text" }, "引き続き、下記の「仕入れ方法」を選択してください", -1))
const _hoisted_4 = { class: "choose-plat-part" }
const _hoisted_5 = { class: "part-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/client/login/plat_d2c.png",
  alt: "",
  class: "part-img"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "normal"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "hover"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "active"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-title" }, "D2C仕入れに進む", -1))
const _hoisted_11 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "part-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/client/login/plat_b2b.png",
  alt: "",
  class: "part-img"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "normal"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "hover"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  class: "active"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-title" }, "B2B仕入れに進む", -1))
const _hoisted_18 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "choose-plat-tip" }, [
  /*#__PURE__*/_createTextVNode(" ※B2BとD2Cの手数料は比較的大きな違いがあり、選ぶ前に必ず"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.theckb.com/price/plan/",
    target: "_blank"
  }, "料金プラン"),
  /*#__PURE__*/_createTextVNode("をご確認ください。 ")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "choose-plat-title",
  style: {"color":"#232323","font-size":"32px"}
}, "로그인 설명", -1))
const _hoisted_21 = { class: "choose-plat-part" }
const _hoisted_22 = { class: "part-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/plat_d2c_kr.png",
  alt: "",
  class: "part-img"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "normal"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "hover"
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "active"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-title" }, "D2C업무를 진행", -1))
const _hoisted_28 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "part-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/plat_b2b_kr.png",
  alt: "",
  class: "part-img"
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "normal"
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "hover"
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  class: "active"
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-title" }, "B2B업무를 진행", -1))
const _hoisted_35 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "choose-plat-tip" }, " B2B와 D2C의 수수료가 다르므로 구체적인 것은 수수료표를 참조하시기 바랍니다. ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "choose-plat-title",
  style: {"color":"#232323"}
}, "REGISTRATION SUCCESS", -1))
const _hoisted_38 = { class: "choose-plat-part" }
const _hoisted_39 = { class: "part-item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/plat_d2c_en.png",
  alt: "",
  class: "part-img"
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "normal"
}, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "hover"
}, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "active"
}, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-title" }, "Enter D2C business", -1))
const _hoisted_45 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = { class: "part-item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/plat_b2b_en.png",
  alt: "",
  class: "part-img"
}, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "normal"
}, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "hover"
}, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  class: "active"
}, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-title" }, "Enter B2B business", -1))
const _hoisted_52 = [
  _hoisted_48,
  _hoisted_49,
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = {
  key: 1,
  class: "h5"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "登録が完了しました", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "引き続き、下記の「仕入れ方法」を選択してください", -1))
const _hoisted_56 = { class: "chose" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createTextVNode(" ※B2BとD2Cの手数料は比較的大きな違いがあり、選ぶ前に必ず"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.theckb.com/price/plan/",
    target: "_blank"
  }, "料金プラン"),
  /*#__PURE__*/_createTextVNode("をご確認ください。 ")
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "로그인 설명", -1))
const _hoisted_59 = { class: "chose" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, " B2B와 D2C의 수수료가 다르므로 구체적인 것은 수수료표를 참조하시기 바랍니다. ", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "REGISTRATION SUCCESS", -1))
const _hoisted_62 = { class: "chose" }

import { t } from '@/plugins/i18n'
import { onMounted, computed } from 'vue'
import store, { useSite, isJA, isKO, isEN } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['h5'],
  emits: ['change'],
  setup(__props, { emit: emits }) {

const props = __props




return (_ctx: any,_cache: any) => {
  return (!__props.h5)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(isJA)())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_2,
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", {
                    class: "part-btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('change', 'd2c')))
                  }, _hoisted_11)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", {
                    class: "part-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('change', 'b2b')))
                  }, _hoisted_18)
                ])
              ]),
              _hoisted_19
            ], 64))
          : _createCommentVNode("", true),
        (_unref(isKO)())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", {
                    class: "part-btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('change', 'd2c')))
                  }, _hoisted_28)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", {
                    class: "part-btn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('change', 'b2b')))
                  }, _hoisted_35)
                ])
              ]),
              _hoisted_36
            ], 64))
          : _createCommentVNode("", true),
        (_unref(isEN)())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("div", {
                    class: "part-btn",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('change', 'd2c')))
                  }, _hoisted_45)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("div", {
                    class: "part-btn",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (emits('change', 'b2b')))
                  }, _hoisted_52)
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("view", _hoisted_53, [
        (_unref(isJA)())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_54,
              _hoisted_55,
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("img", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (emits('change', 'd2c'))),
                  src: "https://static-s.theckb.com/BusinessMarket/Easy/PC/chose_d2c_ja_h5.png",
                  alt: ""
                }),
                _createElementVNode("img", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (emits('change', 'b2b'))),
                  src: "https://static-s.theckb.com/BusinessMarket/Easy/PC/chose_b2b_ja_h5.png",
                  alt: ""
                })
              ]),
              _hoisted_57
            ], 64))
          : _createCommentVNode("", true),
        (_unref(isKO)())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("img", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (emits('change', 'd2c'))),
                  src: "https://static-s.theckb.com/BusinessMarket/Client/login/chose_d2c_ko_h5.png",
                  alt: ""
                }),
                _createElementVNode("img", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (emits('change', 'b2b'))),
                  src: "https://static-s.theckb.com/BusinessMarket/Client/login/chose_b2b_ko_h5.png",
                  alt: ""
                })
              ]),
              _hoisted_60
            ], 64))
          : _createCommentVNode("", true),
        (_unref(isEN)())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _hoisted_61,
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("img", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (emits('change', 'd2c'))),
                  src: "https://static-s.theckb.com/BusinessMarket/Client/login/chose_d2c_en_h5.png",
                  alt: ""
                }),
                _createElementVNode("img", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (emits('change', 'b2b'))),
                  src: "https://static-s.theckb.com/BusinessMarket/Client/login/chose_b2b_en_h5.png",
                  alt: ""
                })
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]))
}
}

})